import React, { useState, useEffect } from "react";
import { buttonText, getTitleParaFun } from "../constants/ConstantsVariable";
import { store } from "../../../redux/store";
import { setSubscriptionInterval } from "../../../redux/actions/auth.action";
import { fetchQuery } from "../../../actions";
import { GET_SUBSCRIPTION_PLAN } from "../actions/paymentGateway";
import CircleLoader from "../../notes/component/CircleLoader";
import HeaderCompNew from "./shares/newHeaderComp";
import SubscriptionPlanBoxCompNew from "./shares/subscriptionBoxNew";
import CommonButtonNew from "./shares/newCommonButton";
import CommonButton from "./shares/CommonButton";

const ScreenTwoCompNew = ({ createStripePayment }) => {
   const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
   const [selectPlans, setSelectPlans] = useState(null);
   const [loading, setLoading] = useState(true); // Loader state

   useEffect(() => {
      setLoading(true); // Start loading
      fetchQuery(GET_SUBSCRIPTION_PLAN, {}, (res) => {
         const plans = res?.data?.getSubscriptionPlanList?.plans || [];
         setSubscriptionPlanList(plans);

         if (plans.length) {
            const defaultPlan = plans.find((plan) => plan.interval === "Yearly") || plans[0];
            setSelectPlans(defaultPlan);
            store.dispatch(setSubscriptionInterval(defaultPlan));
         }
         setLoading(false); // Stop loading after setting plans
      });
   }, []);

   const handlePlanSelection = (plan) => {
      setSelectPlans(plan);
      store.dispatch(setSubscriptionInterval(plan));
   };

   return (
      <>
         {loading ? (
            <div className="flex-center custom-height">
               <CircleLoader />
            </div>
         ) : (
            <>
               <HeaderCompNew text={getTitleParaFun(2)} />
               <div className="pg-subscription-plan-selection-container-new-ui  no-scrollbar pop-in-v2">
                  {subscriptionPlanList.map((plan) => (
                     <SubscriptionPlanBoxCompNew
                        key={plan.priceId}
                        duration={plan.interval}
                        price={plan.amount || 0}
                        isYearlyPlan={plan.interval === "Yearly"}
                        selectPlans={selectPlans?.priceId === plan.priceId} // Compare with priceId for accuracy
                        onClick={() => handlePlanSelection(plan)}
                     />
                  ))}
               </div>
               <div className="pg-button-margin-container-new-ui">
                  <CommonButton
                     id="signUp-button-v2"
                     btnText={buttonText(2)}
                     onClick={createStripePayment}
                     loading={false}
                     isWhiteBtn={false}
                     disabled={!selectPlans}
                  />
               </div>
            </>
         )}
      </>
   );
};

export default ScreenTwoCompNew;
